// extracted by mini-css-extract-plugin
export default {"dialog-body":"UpdateQaDialog_dialog-body__U07ZO"};